import styled, { keyframes } from 'styled-components';

import { colors } from 'seedling/constants';
import valueMap from 'seedling/utils/valueMap';
import { rgba } from 'polished';

const VALID_SIZES = ['small', 'medium', 'large'];
const size = valueMap(VALID_SIZES, 'size');

const flavorStyles = flavor => {
  return flavorStyles.styles[flavor] || {};
};

flavorStyles.styles = {
  green: {
    foregroundColor: colors.mediumGreenhouseGreen,
    backgroundColor: rgba(0, 178, 169, 0.05),
  },
  doubleGreen: {
    foregroundColor: colors.mediumGreenhouseGreen,
    backgroundColor: colors.lightGreenhouseGreen,
  },
  pale: {
    foregroundColor: colors.white,
    backgroundColor: rgba(255, 255, 255, 0.2),
  },
};

/*

Code taken from here: https://projects.lukehaas.me/css-loaders/
and adapted for styled-components

*/

const rotate = keyframes`
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
`;

const foregroundColor = props =>
  props.foregroundColor || flavorStyles(props.flavor).foregroundColor;
const backgroundColor = props =>
  props.backgroundColor || flavorStyles(props.flavor).backgroundColor;

const LoadingSpinner = styled.div`
  display: inline-block;
  ${size.small`font-size: 3px;`}
  ${size.medium`font-size: 6px;`}
  ${size.large`font-size: 20px;`}
  position: relative;
  text-indent: -9999em;
  border-top: .5em solid ${backgroundColor};
  border-right: .5em solid ${backgroundColor};
  border-bottom: .5em solid ${backgroundColor};
  border-left: .5em solid ${foregroundColor};
  transform: translateZ(0);
  animation: ${rotate} 1.1s infinite linear;

  &, &:after {
    border-radius: 50%;
    width: 5em;
    height: 5em;
  }
`;

LoadingSpinner.displayName = 'LoadingSpinner';
LoadingSpinner.defaultProps = {
  size: 'large',
  flavor: 'green',
};

export default LoadingSpinner;
